import {JsonPipe, NgClass} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {AssetService} from '../asset';
import {InspectorService} from '../inspector/inspector.service';
import {SelectionService} from '../selection/selection.service';
import {StateService} from '../state/state.service';
import {StreamService} from '../stream/stream.service';
import {TagService} from '../tag/tag.service';

class Entry {
    value: any;
    component: string;
    subscription: string;

    constructor(value: any, component: string, subscription: string) {
        this.value = value;
        this.component = component;
        this.subscription = subscription;
    }
}

@Component({
    selector: 'frog-service-subscriber',
    templateUrl: './service-subscriber.component.html',
    styleUrls: ['./service-subscriber.component.scss'],
    imports: [NgClass, JsonPipe],
})
export class ServiceSubscriberComponent implements OnInit {
    public output: Entry[];

    constructor(
        private assetService: AssetService,
        private tagService: TagService,
        private inspectorService: InspectorService,
        private streamService: StreamService,
        private selectionService: SelectionService,
        private stateService: StateService,
    ) {
        this.output = [];
    }

    ngOnInit(): void {
        this.assetService.filteredAssets.subscribe((assets) =>
            assets.forEach((asset) =>
                this.output.push(
                    new Entry(this.copyObject(asset), 'AssetService', 'filteredAssets'),
                ),
            ),
        );
        this.assetService.assetUpdated.subscribe((asset) =>
            this.output.push(new Entry(this.copyObject(asset), 'AssetService', 'assetsUpdated')),
        );
        this.tagService.tags.subscribe((tags) =>
            tags.forEach((tag) =>
                this.output.push(new Entry(this.copyObject(tag), 'TagService', 'tags')),
            ),
        );
        this.inspectorService.asset.subscribe((asset) =>
            this.output.push(new Entry(this.copyObject(asset), 'InspectorService', 'asset')),
        );
        this.streamService.streams.subscribe((streams) =>
            streams.forEach((stream) =>
                this.output.push(new Entry(this.copyObject(stream), 'StreamService', 'asset')),
            ),
        );
        this.streamService.stream.subscribe((stream) =>
            this.output.push(new Entry(this.copyObject(stream), 'StreamService', 'stream')),
        );
        this.selectionService.selection.subscribe((stream) =>
            this.output.push(new Entry(this.copyObject(stream), 'SelectionService', 'selection')),
        );
        this.stateService.state.subscribe((state) =>
            this.output.push(new Entry(this.copyObject(state), 'StateService', 'state')),
        );
    }

    copyObject(obj) {
        return Object.assign({}, obj);
    }

    reset() {
        this.output = [];
    }
}
